import { IBaseStorage, StorageKeyTopic } from "./types";
// Abstract
// Takes the name of the storage
/* eslint-disable no-console */

const BaseStorage = function (this: IBaseStorage, args: string) {
	if (args) {
		try {
			// webpack was crying here. It wouldnt let it build without this. Window does not exist server side.
			if ((global as any).adapterReceiver) {
				(global as any).adapterReceiver.loaded(args[0], this);
			} else {
				console.error("Global Adapter Receiver not found on the global object. Fatal error.");
			}
		} catch (e) {
			console.error("BaseStorage constructor", e);
		}
	}
	this.setBaseName = function (baseName: string): void {
		this.baseName = baseName;
	};

	this.setUser = function (user: string): void {
		this.userName = user;
	};

	this.save = function (params: StorageKeyTopic, callback: Function) {
		const msg = "Save method not fulfilled in the active storage model.";
		console.warn(msg);
	};

	this.get = function (params: StorageKeyTopic, callback: Function) {
		const msg = "Get method not fulfilled in the active storage model.";
		console.warn(msg);
	};

	this.keys = function (params: StorageKeyTopic, callback: Function) {
		const msg = "Keys method not fulfilled in the active storage model.";
		console.warn(msg);
	};

	this.delete = function (params: StorageKeyTopic, callback: Function) {
		const msg = "Delete method not fulfilled in the active storage model.";
		console.warn(msg);
	};

	this.clearCache = function (params: StorageKeyTopic, callback: Function) {
		const msg = "Clear cache method not fulfilled in the active storage model.";
		console.warn(msg);
	};

	this.empty = function (callback: Function) {
		const msg = "Empty method not fulfilled in the active storage model.";
		console.warn(msg);
	};

	this.getMultiple = function () {};

	// return full underlying key (based baseName + userName + topic + key)
	this.getCombinedKey = function (self: IBaseStorage, params: StorageKeyTopic): string {
		return `${self.baseName}:${self.userName}:${params.topic}:${params.key}`;
	};

	// return prefix used to filter keys
	this.getKeyPreface = function (self: IBaseStorage, params: StorageKeyTopic): string {
		let preface = `${self.baseName}:${self.userName}:${params.topic}:`;
		if ("keyPrefix" in params) {
			preface = preface + params.keyPrefix;
		}
		return preface;
	};
};

export default BaseStorage;
